/*
  CEBE theme — assets/cebe.js, part 4 of 4: checkout, quantity steppers, reveal, shared interface and start.
  Load all parts in this order, each with defer: cebe-part-1.js, cebe-part-2.js, cebe-part-3.js, cebe-part-4.js.
  Made by website/review/sammel-2026-10-03/werkzeuge/zusammenfuehren.py from assets/cebe.js (MD5 46a65575485db7a4e2796e006f51aee3);
  every Shopify upload file must stay below 26 000 bytes. Between the markers stands the original code; the only change:
  a name that one part changes and another reads, or that comes from a later part, reads cebeShared.<name> (one private
  object, window.__cebeParts.main). See website/review/sammel-2026-10-03/TEILUNG.md.
*/
(function () {
  'use strict';

  var cebeShared = (window.__cebeParts = window.__cebeParts || {}).main || (window.__cebeParts.main = {});
  if (cebeShared.done !== 3) return; // part 3 did not finish (error or early return): stop, as the single file would
  var config = cebeShared.config;
  var reduceMotion = cebeShared.reduceMotion;
  var $ = cebeShared.$;
  var $$ = cebeShared.$$;
  var announce = cebeShared.announce;
  var readJson = cebeShared.readJson;
  var errorText = cebeShared.errorText;
  var CART_WAIT = cebeShared.CART_WAIT;
  var limitedJson = cebeShared.limitedJson;
  var initHeader = cebeShared.initHeader;
  var initMenu = cebeShared.initMenu;
  var SECTION = cebeShared.SECTION;
  var currentCount = cebeShared.currentCount;
  var updateExpress = cebeShared.updateExpress;
  var refreshDrawer = cebeShared.refreshDrawer;
  var onCartPage = cebeShared.onCartPage;
  var drawerAvailable = cebeShared.drawerAvailable;
  var openDrawer = cebeShared.openDrawer;
  var cartIdle = cebeShared.cartIdle;
  var clearQueue = cebeShared.clearQueue;
  var whenIdle = cebeShared.whenIdle;
  var exclusive = cebeShared.exclusive;
  var drawerSurface = cebeShared.drawerSurface;
  var initDrawer = cebeShared.initDrawer;
  var initCartPage = cebeShared.initCartPage;
  var giftFlush = cebeShared.giftFlush;
  var initGift = cebeShared.initGift;

  /* ---- assets/cebe.js, lines 1029–1346 ---- */

  /* ---------- "Check out": calm busy state; waits for open quantity changes ----------
     The checkout must never open with an old quantity. A cart write whose answer is lost or late (an add in
     assets/cebe-product.js, a quantity change here) may still be carried out by the server, and no time limit proves
     otherwise. While such a write is on its way or unconfirmed, "Check out" does not start: it reads the cart
     (/cart.js), draws it as the server holds it and says so. It starts once the cart confirms every write, or once nothing
     is on its way any more and the customer, told so and shown the cart, checks out again (their decision). */
  var checkoutWait = 0;
  var stuckTimer = 0;
  cebeShared.decided = -1; // holdSerial() when the customer was told that checking out again continues with the cart as shown
  var heldNote = null; // { surface, message }: the reason "Check out" gave for not starting, while it is on screen
  // Texts (M-9). Locale keys may replace them through window.cebe.strings (layout/theme.liquid).
  var HELD = config.strings.checkoutHeld || 'A change to your bag hasn’t been confirmed yet, so checkout hasn’t started. Your bag is shown as it is now.';
  var DECIDE = config.strings.checkoutDecide || 'To continue with this bag, check out again.'; // nothing on its way any more
  var LATER = config.strings.checkoutLater || 'Please check out again in a moment.'; // a change is still on its way
  // Each hold: state() → 'travelling' (a write is on its way), 'unclear' (unconfirmed, nothing on its way) or '';
  // check(cart) takes what the cart, read and drawn, now confirms; accept() is the customer's decision; serial() counts
  // its writes. Optional: changing(key) and changed(key, cart) hear of each quantity change and its answer.
  var holds = [
    {
      state: function () {
        return Object.keys(cebeShared.unsure).length ? 'unclear' : '';
      },
      check: function (data) {
        var lines = {};
        ((data && data.items) || []).forEach(function (item) {
          lines[item.key] = (lines[item.key] || 0) + (item.quantity || 0);
        });
        Object.keys(cebeShared.unsure).forEach(function (key) {
          if ((lines[key] || 0) === cebeShared.unsure[key]) delete cebeShared.unsure[key];
        });
      },
      accept: function () {
        cebeShared.unsure = {};
      },
      serial: function () {
        return cebeShared.unsureSerial;
      }
    }
  ];

  function heldState() {
    var state = '';
    holds.forEach(function (hold) {
      var own = hold.state();
      if (own === 'travelling' || (own && !state)) state = own;
    });
    return state;
  }

  function holdSerial() {
    var sum = 0;
    holds.forEach(function (hold) {
      sum += hold.serial();
    });
    return sum;
  }

  // What holds "Check out" may have changed. Express and wallet buttons start a checkout of their own: hidden while it
  // is held (the cart page; the drawer, if they are switched on there). Once nothing holds it any more, the reason it
  // gave goes from the screen.
  function syncHeld() {
    var held = heldState() !== '';
    $$('[data-cebe-express]').forEach(function (block) {
      if (Boolean(block.cebeHeld) === held) return;
      block.cebeHeld = held;
      if (cebeShared.drawer && cebeShared.drawer.contains(block)) updateExpress(currentCount());
      else block.hidden = held;
    });
    if (held || !heldNote) return;
    var node = $('[data-cebe-drawer-error], [data-cebe-cart-error]', heldNote.surface.scope);
    if (node && node.textContent === heldNote.message) heldNote.surface.error('');
    heldNote = null;
  }

  // In the queue: reads the cart and draws it as the server holds it; once it is drawn, every hold takes what the cart
  // now confirms. Resolves with what is still held ('travelling' or 'unclear'), with 'clear', or with 'unreadable'.
  function confirmCart(surface) {
    return new Promise(function (resolve) {
      exclusive(function () {
        var read = limitedJson((config.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }, CART_WAIT);
        return Promise.all([read, surface.refresh()]).then(
          function (both) {
            if (both[1]) {
              holds.forEach(function (hold) {
                hold.check(both[0]);
              });
            }
            syncHeld();
            resolve(both[1] ? heldState() || 'clear' : 'unreadable');
            return both[1];
          },
          function () {
            resolve('unreadable');
            return false;
          }
        );
      });
    });
  }

  // Where "Check out" says why it has not started: the cart page, or the drawer.
  function checkoutSurface(button) {
    return cebeShared.pageSurface && !(cebeShared.drawer && cebeShared.drawer.contains(button)) ? cebeShared.pageSurface : drawerSurface;
  }

  function submitCheckout(form, button) {
    checkoutSurface(button).error(''); // on the way: no reason left on screen
    if (!$('input[name="checkout"]', form)) {
      var field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'checkout';
      form.appendChild(field);
    }
    leaving(button);
    form.submit(); // POST /cart with "checkout" leads to the checkout
  }

  // "Check out" has not started: the button is free, the reason is shown and spoken.
  function held(button, surface, state) {
    setStateful(button, 'idle');
    var message = state === 'unreadable' ? config.strings.error : HELD + ' ' + (state === 'unclear' ? DECIDE : LATER);
    if (state === 'unclear') cebeShared.decided = holdSerial();
    surface.error(message);
    announce(message);
    heldNote = state === 'unreadable' ? null : { surface: surface, message: message };
    syncHeld();
  }

  // The queue is idle. A write on its way or unconfirmed: the cart is read and shown first (read = true), and the
  // checkout starts only if that confirms everything. A failure reported by the queue (ok = false): the button is free
  // again; whoever failed has said why.
  function proceed(form, button, ticket, ok, read) {
    if (ticket !== checkoutWait) return setStateful(button, 'idle');
    var state = heldState();
    if (state && read) {
      var surface = checkoutSurface(button);
      confirmCart(surface).then(function (result) {
        if (ticket !== checkoutWait) return;
        if (result !== 'clear') return held(button, surface, result);
        whenIdle(function (next) {
          proceed(form, button, ticket, next, false);
        });
      });
      return;
    }
    if (state) return held(button, checkoutSurface(button), state);
    if (!ok) return setStateful(button, 'idle');
    submitCheckout(form, button);
  }

  function setStateful(button, state) {
    if (state === 'idle') {
      button.removeAttribute('data-state');
      button.removeAttribute('aria-disabled');
    } else {
      button.setAttribute('data-state', state);
      button.setAttribute('aria-disabled', 'true');
    }
  }

  // Closing the drawer cancels a checkout that still waits for the queue.
  function cancelCheckout(scope) {
    checkoutWait += 1;
    cebeShared.decided = -1;
    window.clearTimeout(stuckTimer);
    $$('[data-cebe-checkout]', scope).forEach(function (button) {
      setStateful(button, 'idle');
    });
  }

  // On the way to the checkout; a stopped or failed navigation must not leave the button dead.
  function leaving(button) {
    setStateful(button, 'busy');
    window.clearTimeout(stuckTimer);
    stuckTimer = window.setTimeout(function () {
      setStateful(button, 'idle');
    }, 8000);
  }

  function initCheckout() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      var button = event.submitter && event.submitter.matches('[data-cebe-checkout]') ? event.submitter : null;
      if (!button && !event.submitter && form.matches('[data-cebe-checkout-form]')) button = $('[data-cebe-checkout]', form);
      if (!button) return;
      if (button.getAttribute('aria-disabled') === 'true') {
        event.preventDefault(); // already on its way
        return;
      }
      giftFlush(); // a gift message still waiting for the typing pause is saved first
      var ticket = ++checkoutWait;
      // Told that checking out again continues with the cart as shown, and nothing new since: that is the decision.
      if (cebeShared.decided === holdSerial() && heldState() === 'unclear') {
        holds.forEach(function (hold) {
          hold.accept();
        });
        syncHeld();
      }
      cebeShared.decided = -1;
      if (!cartIdle() || heldState()) {
        // The checkout must never open with an old quantity.
        event.preventDefault();
        setStateful(button, 'busy');
        whenIdle(function (ok) {
          proceed(form, button, ticket, ok, true);
        });
        return;
      }
      checkoutSurface(button).error(''); // on the way: no reason left on screen
      window.setTimeout(function () {
        if (ticket === checkoutWait) leaving(button);
      }, 150);
    });

    // Back from the checkout (back-forward cache): no stale number, no spinner.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      $$('.cebe-stateful').forEach(function (button) {
        setStateful(button, 'idle');
      });
      cebeShared.decided = -1;
      drawerSurface.error(''); // no reason from before the checkout
      clearQueue();
      if (onCartPage()) window.location.reload();
      else refreshDrawer(true); // with the gift option as the server holds it now
    });
  }

  /* ---------- Quantity steppers outside the cart lines (product page; cart lines without fetch) ---------- */
  function initSteppers() {
    document.addEventListener('click', function (event) {
      var step = event.target.closest('[data-cebe-qty-step]');
      // Cart lines go through the queue; counting here too would count twice.
      if (!step || (window.fetch && step.closest('[data-cebe-key]'))) return;
      var input = $('input', step.closest('[data-cebe-qty]'));
      if (!input) return;
      var min = parseInt(input.min, 10);
      if (isNaN(min)) min = 0;
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.dataset.cebeQtyStep, 10);
      input.value = String(Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Fade-in: 8 px, 400 ms, once; never for what is already on screen ---------- */
  function revealNow(nodes) {
    nodes.forEach(function (node) {
      node.classList.add('is-visible');
    });
  }

  function initReveal() {
    var nodes = $$('[data-cebe-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window) || nodes.length === 0) return;
    var pending = nodes.filter(function (node) {
      return node.getBoundingClientRect().top >= window.innerHeight;
    });
    revealNow(
      nodes.filter(function (node) {
        return pending.indexOf(node) === -1;
      })
    );
    document.documentElement.classList.add('cebe-reveal-ready');
    var observer = new IntersectionObserver(
      function (entries) {
        var batch = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var node = entry.target;
          node.style.transitionDelay = Math.min(batch, 5) * 60 + 'ms';
          batch += 1;
          node.classList.add('is-visible');
          observer.unobserve(node);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    pending.forEach(function (node) {
      observer.observe(node);
    });
  }

  /* Shared with assets/cebe-product.js */
  window.cebe = config;
  config.$ = $;
  config.$$ = $$;
  config.announce = announce;
  config.readJson = readJson;
  config.errorText = errorText;
  config.revealNow = revealNow;
  config.reduceMotion = reduceMotion;
  config.cart = {
    sectionId: function () {
      return SECTION;
    },
    run: exclusive, // (task(draw) → promise; false = not done or outcome unknown)
    hold: function (hold) {
      holds.push(hold); // assets/cebe-product.js: its adds whose outcome is not confirmed
    },
    holdChanged: syncHeld, // assets/cebe-product.js: what holds "Check out" may have changed
    open: openDrawer,
    available: drawerAvailable
  };

  function init() {
    initHeader();
    initMenu();
    initDrawer();
    initCartPage();
    initGift();
    initCheckout();
    initSteppers();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* ---- end of lines 1029–1346 ---- */

  cebeShared.holds = holds;
  cebeShared.syncHeld = syncHeld;
  cebeShared.cancelCheckout = cancelCheckout;
  cebeShared.done = 4;
})();
